// import Vue from 'vue';

export default (router) => {
    router.beforeEach((from, to, next) => {
        // 丢到使用的时候检测是否过期
        // Vue.$storage.check('STORE_SERVICE').then((isOv) => {
        //     console.log(isOv);
        // }).catch((err) => {
        //     console.log(err);
        // });
        next();
    });
};



// WEBPACK FOOTER //
// ./src/router/middlewares/checkStat.js